import AssociationSeller from './AssociationSeller'

export default AssociationSeller
